import React from "react";
import { Box } from "@mui/material";

type TabPanelProps<TId extends string> = {
  tabIndex: number;
  id: TId;
  children: React.ReactNode;
};

const createTabPanel = <TTabs extends Record<string, number>>(
  tabs: TTabs,
  testIdPrefix: string,
): React.FC<TabPanelProps<keyof TTabs & string>> => {
  const TabPanel: React.FC<TabPanelProps<keyof TTabs & string>> = ({
    tabIndex,
    id,
    children,
  }) => (
    <Box
      sx={{ display: tabIndex === tabs[id] ? "block" : "none" }}
      data-testid={`${testIdPrefix}-${id}`}
    >
      {children}
    </Box>
  );

  return TabPanel;
};

export { createTabPanel };
